import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const startEndRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const start = control.get('dateStart')?.value;
  const end = control.get('dateEnd')?.value;

  if (!start || !end) {
    return null;
  }

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (startDate > endDate) {
    return { dateRangeInvalid: true };
  }
  return null;
};
